import DisbursementContainer from './disbursement.container';

export default DisbursementContainer;
